import React from "react";
import PropTypes from "prop-types";
const GoogleIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 24}
    height={height || size || 24}
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
    fill={color || "var(--color-easil-gray-x-dark)"}
  >
    <title>{title}</title>
    <path
      fillRule="nonzero"
      d="M8.003 6.856V9.6h4.538c-.185 1.178-1.372 3.45-4.538 3.45-2.731 0-4.96-2.263-4.96-5.05s2.229-5.05 4.96-5.05c1.553 0 2.594.662 3.188 1.234l2.171-2.09C11.97.788 10.163 0 8.004 0c-4.422 0-8 3.578-8 8 0 4.422 3.578 8 8 8 4.616 0 7.681-3.247 7.681-7.816 0-.525-.056-.925-.125-1.325l-7.556-.003z"
    />
  </svg>
);
GoogleIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default GoogleIcon;
